module.exports = __webpack_public_path__ + "static/media/Gio.486349f2.jpg";